export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-950">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          {/* Left: Visual */}
          <div className="flex-shrink-0 w-full max-w-sm">
            <div className="relative mx-auto w-48 h-80 bg-background-900 rounded-3xl border-4 border-background-700 overflow-hidden shadow-2xl">
              <div className="absolute top-0 left-0 right-0 h-8 bg-background-800 flex items-center justify-center">
                <div className="w-16 h-1.5 bg-background-600 rounded-full"></div>
              </div>
              <div className="pt-10 px-4 flex flex-col items-center">
                <span className="w-14 h-14 flex items-center justify-center bg-primary-500 rounded-2xl mb-4">
                  <i className="ri-play-fill text-background-50 text-2xl"></i>
                </span>
                <span className="text-background-50 font-bold text-sm mb-1">51视频</span>
                <span className="text-background-400 text-[10px]">随时随地 · 高清观影</span>
                <div className="mt-6 w-full space-y-2">
                  {[1, 2, 3].map((i) => (
                    <div key={i} className="h-10 bg-background-800 rounded-lg"></div>
                  ))}
                </div>
                <div className="mt-4 w-full">
                  <div className="h-8 bg-accent-500 rounded-full flex items-center justify-center">
                    <span className="text-background-50 text-[10px] font-bold">立即下载</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Text */}
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-bold text-background-50">移动端看片</h2>
            <p className="text-sm text-background-300 mt-3 leading-relaxed max-w-lg mx-auto lg:mx-0">
              51视频移动客户端现已支持 iOS 与 Android 双平台。无论您在地铁、公交还是旅途中，
              打开手机即可畅享海量高清影视内容。专属移动端优化技术，更低流量消耗，更流畅的播放体验。
              支持离线缓存，没网也能看。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-6">
              <button className="inline-flex items-center gap-2 bg-background-50 text-foreground-950 px-5 py-2.5 rounded-full font-medium text-sm hover:bg-background-100 transition-colors whitespace-nowrap">
                <i className="ri-apple-fill text-lg"></i>
                iOS 版本
              </button>
              <button className="inline-flex items-center gap-2 bg-background-50/10 border border-background-50/30 text-background-50 px-5 py-2.5 rounded-full font-medium text-sm hover:bg-background-50/20 transition-colors whitespace-nowrap">
                <i className="ri-android-fill text-lg"></i>
                Android 版本
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}